import PixelSentence from "./PixelSentence";
import styles from "./InGameTextbox.module.css";
import Sprite from "../object-graphics/Sprite";
import { TILES } from "../../helpers/tiles";
import { useState } from "react";

export default function InGameTextbox({ level }) {
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  return (
    <div className={`${styles.textbox} ${isAnimatingOut ? styles.out : ""}`}>
      <div className={styles.textboxInner}>
        <div className={styles.characterAvatar}>
          <div className={styles.scaledSprite}>
            <Sprite frameCoord={TILES.CIABATTA_RIGHT} size={48} />
          </div>
        </div>
        <div>
          <PixelSentence
            preDelayMs={
              1800
            } /* Delay the text because we need box to animate in */
            textString={level.story}
            onDone={() => {
              setIsAnimatingOut(true);
              setTimeout(() => {
                level.closeStory();
              }, 300);
            }}
          />
        </div>
      </div>
    </div>
  );
}
